module.exports = __webpack_public_path__ + "static/media/logoTicketBG.755a553f.png";